<template>
  <SimpleDataWithVariation
    :title="title"
    :item-id="itemId"
    :value="value"
    :variation="variation"
    :raw-variation="rawVariation"
    :request-status="requestStatus"
    :comparation-value="comparationValue"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import SimpleDataWithVariation from '@/components/cards/models/SimpleDataWithVariation';
import { mapActions } from 'vuex';
import EventBus from '@/utils/event-bus';
import { formatSocialNumberWithDecimal } from '@/utils/formatter';

export default {
  name: 'CollectedPosts',
  components: {
    SimpleDataWithVariation,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      value: '',
      variation: '',
      rawVariation: '',
      comparationValue: '',
    };
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getWarroomService',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      this.getWarroomService({
        itemId: this.itemId,
        servicePath: 'monitoringOverview',
      })
        .then(response => {
          this.value = response.collected_mentions;
          this.variation = response.collected_mentions_variation;
          this.rawVariation = response.collected_mentions_variation;
          this.comparationValue = formatSocialNumberWithDecimal(response.previous_collected_mentions);
          this.requestStatus = 'success';

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch(error => {
          console.error(error);
          this.requestStatus = 'error';
        });
    },
  },
};
</script>

<style scoped lang="scss">
</style>
